import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/role_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Role',
    column_type: 'string',
    column_name: 'name',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'custom'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
  kind_in: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'custom'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'custom_permissions': { required: false, disabledUpdate: false },
  },
  'custom_permissions': {
    'user': { required: false, disabledUpdate: true },
    'admin_user': { required: false, disabledUpdate: true },
    'student': { required: false, disabledUpdate: true },
    'invite_relationship': { required: false, disabledUpdate: true },
    'article': { required: false, disabledUpdate: true },
    'special_column': { required: false, disabledUpdate: true },
    'youth_camp': { required: false, disabledUpdate: true },
    'book_club': { required: false, disabledUpdate: true },
    'book_list': { required: false, disabledUpdate: true },
    'podcast': { required: false, disabledUpdate: true },
    'experience_comment': { required: false, disabledUpdate: true },
    'youth_camp_experience_comment': { required: false, disabledUpdate: true },
    'apply_record': { required: false, disabledUpdate: true },
    'price_type_template': { required: false, disabledUpdate: true },
    'reason': { required: false, disabledUpdate: true },
    'seek_truth_video': { required: false, disabledUpdate: true },
    'seek_truth_weekly': { required: false, disabledUpdate: true },
    'banner': { required: false, disabledUpdate: true },
    'active_storage_blob': { required: false, disabledUpdate: true },
    'custom_page': { required: false, disabledUpdate: true },
    'page': { required: false, disabledUpdate: true },
    'custom_post_list': { required: false, disabledUpdate: true },
    'normal_comment': { required: false, disabledUpdate: true },
    'hot_word': { required: false, disabledUpdate: true },
    'invoice_apply_record': { required: false, disabledUpdate: true },
    'application': { required: false, disabledUpdate: true },
  },
  'custom_permissions.user': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.admin_user': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.student': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.invite_relationship': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.article': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.special_column': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.youth_camp': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.book_club': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.book_list': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.podcast': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.experience_comment': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.youth_camp_experience_comment': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.apply_record': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.price_type_template': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.reason': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.seek_truth_video': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.seek_truth_weekly': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.banner': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.active_storage_blob': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.custom_page': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
    'publish': { required: false, disabledUpdate: true },
  },
  'custom_permissions.page': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.custom_post_list': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.normal_comment': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.hot_word': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.invoice_apply_record': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.application': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('Role', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Role', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
